import { config, debug, i18n, inject, LoginAPI, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import authStore from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { safeWindowOpen } from "util/helpers";
import { TradingPreferencesOverview } from "./TradingPreferencesOverview";
import { TradingPreferencesRoutes } from "./TradingPreferencesRoutes";
import { TradingPreferencesSigning } from "./TradingPreferencesSigning";
import { TradingPreferencesStore } from "./TradingPreferencesStore";
import { TradingPreferencesSuccess } from "./TradingPreferencesSuccess";
import { TradingPreferencesSummary } from "./TradingPreferencesSummary";


type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class TradingPreferencesContainer extends React.Component<IProps> {
    store: TradingPreferencesStore;

    constructor(props: any) {
        super(props);
        this.store = new TradingPreferencesStore();
    }

    async componentDidMount() {
        try {
            georgeWebHeaderStore.configure({
                title: ui.__("tradingPreferences.document.title"),
                backBehaviour: "tokenExchange"
            });

            if (!authStore.authorized) {
                safeWindowOpen(LoginAPI.getLoginUrl("C02345N6", window.location.href));
            } else {
                await this.store.loadData();
            }

        } catch (error) {
            debug.log("### TradingPreferencesContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("tradingPreferences.document.title");
        return (
            <div>
                <Route exact path={TradingPreferencesRoutes.ROOT} component={this.withStore(TradingPreferencesOverview)} />
                <Route path={TradingPreferencesRoutes.SUMMARY} component={this.withStore(TradingPreferencesSummary)} />
                <Route path={TradingPreferencesRoutes.SIGNING} component={this.withStore(TradingPreferencesSigning)} />
                <Route path={TradingPreferencesRoutes.SUCCESS} component={this.withStore(TradingPreferencesSuccess)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/tradingPreferences/TradingPreferencesContainer.tsx